import BatchAction from './BatchAction';

export default BatchAction;
